export default "__VITE_ASSET__DuTr362a__"